import { Component } from '@theme/component';
import { debounce, fetchConfig } from '@theme/utilities';
import { cartPerformance } from '@theme/performance';

class CartDeliveryDate extends Component {
  #required = true;
  #dateInput = null;
  #dateWrapper = null
  #messageContainer = null;
  #datePickerInitialised = false;

  connectedCallback() {
    super.connectedCallback?.();

    this.addEventListener('input', this.onInput);
    this.addEventListener('change', this.onInput);

    this.initialiseAfterMorph();
  }

  disconnectedCallback() {
    this.removeEventListener('input', this.onInput);
    this.removeEventListener('change', this.onInput);

    super.disconnectedCallback?.();
  }

  initialiseAfterMorph() {
    this.#messageContainer = this.querySelector('.cart-delivery-date__message');
    this.#dateInput = this.querySelector('.iw-order-delivery-dt-deliveryDateVal');
    this.#dateWrapper = this.querySelector('.iweb-order-delivery-dt-pro');
    this.initialiseDatePicker();
    this.emitDateChange();

  }

  initialiseDatePicker() {
    if (this.#datePickerInitialised) return;
    const hasMountPoint = this.#dateWrapper;
    if (!hasMountPoint) return;

    if (typeof window.display_calendar_onTime !== 'function') {
      return;
    }

    this.#datePickerInitialised = true;
    //window.display_calendar_onTime();
    window.IW_dt_loadJavascriptAsynch();

  }

  onInput = (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;

    if (!event.target.matches('.iw-order-delivery-dt-deliveryDateVal')) {
      return;
    }

    this.#dateInput = event.target;
    this.emitDateChange();
  };

  emitDateChange = () => {
    const value =
      this.#dateInput?.value ??
      this.#dateInput?.value ??
      '';

    this.dispatchEvent(
      new CustomEvent('cart-delivery-date:change', {
        bubbles: true,
        detail: {
          value,
          valid: value.trim() !== '',
          required: this.#required,
        },
      }),
    );
  };

  setRequired(required) {
    this.#required = Boolean(required);

    if (typeof window.OTD_resultJson === 'object' && window.OTD_resultJson) {
      window.OTD_resultJson.required = this.#required ? '1' : '0';

      if (typeof window.shipping_show === 'function') {
        window.shipping_show(window.OTD_resultJson);
      }
    }

    this.emitDateChange();
  }

  showNationwideMessage() {
    if (!this.#messageContainer) return;

    this.#messageContainer.innerHTML =
      '<b>NZ-Wide Delivery</b> Our Premium Plant Collection ships across New Zealand in specially designed plant boxes.<ul><li>North Island: 2–3 business days.</li><li>South Island and rural: allow an additional 2 days.</li></ul>';
    this.#messageContainer.hidden = false;
    this.hideDatePicker();
  }

  showMixedMessage() {
    if (!this.#messageContainer) return;

    this.#messageContainer.innerHTML = `
      <b>NZ-Wide Delivery</b> Our Premium Plant Collection ships across New Zealand in specially designed plant boxes.<ul><li>North Island: 2–3 business days.</li><li>South Island and rural: allow an additional 2 days.</li></ul>
      <p style="margin-top:10px;">
        <strong>For local deliveries and pickups, you can select the date below:</strong>
      </p>
    `;

    this.#messageContainer.hidden = false;
    this.showDatePicker();
  }

  showLocalOnly() {
    if (this.#messageContainer) {
      this.#messageContainer.hidden = true;
      this.#messageContainer.innerHTML = '';
    }

    this.showDatePicker();
  }

  hideDatePicker() {
    this.#dateWrapper?.setAttribute('hidden', '');
  }

  showDatePicker() {
    this.#dateWrapper?.removeAttribute('hidden');
  }
}

if (!customElements.get('cart-delivery-date')) {
  customElements.define('cart-delivery-date', CartDeliveryDate);
}